import {useProposition} from '@myparcel-frontend/proposition';
import {VettingStatus} from '@myparcel-frontend/types';
import {ref, watch} from 'vue';
import useAccount from '../../composables/useAccount/useAccount';
import useShop from '../../composables/useShop/useShop';

const shouldShowVettingModal = ref(false);
const initialized = ref(false);

export function useVettingCheck() {
  const {accountSettings} = useAccount();
  const {currentShop} = useShop();
  const {proposition} = useProposition();

  if (!initialized.value) {
    initialized.value = true;

    shouldShowVettingModal.value = Boolean(
      // Vetting modal shows when any vetting field is enabled for this proposition.
      Object.values(proposition.value.billing.vetting).some(Boolean) &&
      /*
       * The API takes care of making the whole backoffice inaccessible when users have not been vetted. Test users
       * get full access through the API already while not being vetted, so we can safely hide the modal for them.
       */
      !accountSettings.value.is_test &&
      currentShop.value.vetting?.status !== VettingStatus.Passed,
    );

    watch(
      () => currentShop.value.vetting?.status,
      (status) => {
        if (status === VettingStatus.Passed) {
          shouldShowVettingModal.value = false;
        }
      },
    );
  }

  return {
    shouldShowVettingModal,
  };
}
